






























































































































































































import { Component, Vue } from "vue-property-decorator";
import BusinessSelect from "@/components/dashboard/BusinessSelect.vue";
import {
  TitleTemplatePublic,
  SelectedCountry,
  RedCapital
} from "@/configuration";
import API from "@/api";
import { mapState } from 'vuex'

@Component({
  metaInfo: {
    title: "Solicitudes aprobadas",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  computed: {
    ...mapState(["user", "setOpenMenuPanel"]),
    setOpenMenuPanel(){
      return this.$store.state.openMenuPanel;
    }
  },
  data() {
    return {
      active: null,
      businessCount: 0,
      facturasHeaders: [
        { text: "ID", value: "project.id" },
        { text: "Folio", value: "factura.folio" },
        { text: "Nombre Pagador", value: "factura.deudor.nombre" },
        { text: "Fecha vencimiento", value: "factura.fecha_estimada_pago" },
        { text: "Rut Pagador", value: "factura.deudor.rut" },
        { text: "Estado Factura", value: "factura.pagado" },
        { text: "Monto vencimiento", value: "factura.monto" }
      ],
      creditosHeaders: [
        { text: "ID", value: "project.id" },
        { text: "Tipo", value: "project.credito_tipo.valor" },
        { text: "Fecha vencimiento", value: "pago.fecha" },
        { text: "Estado cuota", value: "pago.pagada" },
        { text: "Monto vencimiento", value: "pago.monto" }
      ],
      business: null,
      companySelected: 0,
      companyProjects: null
    };
  },
  watch: {
    async companySelected(val) {
      // @ts-ignore
      await this.loadCompanyCreditRequests(val);
    }
  },
  async beforeMount() {
    this.$data.businessCount = await API.getBusiness();
  },
  methods: {
    async loadCompanyCreditRequests(id: number) {
      this.$data.companyProjects = null;
      this.$data.companyProjects = await API.projectsByCompanyId(id);
    },
    getInvoices() {
      if (this.$data.companyProjects != null) {
        let invoices: any[] = [];

        this.$data.companyProjects.factoring.forEach((project: any) => {
          project.proyecto_factura.facturas.forEach((invoice: any) => {
            let _project = Object.assign({}, project);
            delete _project["proyecto_factura"];
            invoices.push({
              project: _project,
              factura: invoice
            });
          });
        });

        return invoices;
      } else {
        return [];
      }
    },
    getCuotas() {
      if (this.$data.companyProjects != null) {
        let cuotas: any[] = [];

        this.$data.companyProjects.creditos.forEach((project: any) => {
          let _project = Object.assign({}, project);
          delete _project["pagos"];

          project.pagos.forEach((pago: any) => {
            cuotas.push({
              project: _project,
              pago: pago
            });
          });
        });

        return cuotas;
      } else {
        return [];
      }
    },
    paymentStatus(payment: any) {
      return payment.pago.pagada
        ? payment.pago.confirmado
          ? "Pagada y Confirmada"
          : "Pagada pero no confirmado"
        : payment.pago.confirmado
        ? "Confirmada"
        : "Sin confirmar";
    },
    goToAction() {
      this.$store.commit("deleteSimulation");
      this.$router.push({
        path: "/evaluacion"
      });
    },
    goToAction2() {
      this.$store.commit("deleteSimulation");
      this.$router.push({
        path: "/angloamerican"
      });
    }
  },
  components: {
    BusinessSelect
  }
})
export default class Projects extends Vue {}
